import React from 'react';
import { Link } from 'react-router-dom';

const CompletelyPublicPage = () => {
  return (
    <div style={{
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif'
    }}>
      <header style={{
        borderBottom: '1px solid #eaeaea',
        paddingBottom: '20px',
        marginBottom: '30px'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: '10px'
        }}>
          Public Brands Explorer
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#666'
        }}>
          This page is completely public and doesn't require authentication.
        </p>
      </header>

      <main>
        <div style={{
          backgroundColor: '#f0f9ff',
          border: '1px solid #93c5fd',
          borderLeft: '4px solid #3b82f6',
          borderRadius: '6px',
          padding: '16px',
          marginBottom: '24px'
        }}>
          <p style={{ color: '#1e40af' }}>
            This is a standalone page that doesn't rely on any other components.
          </p>
        </div>

        <h2 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#333'
        }}>Sample Brands</h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
          gap: '20px',
          marginBottom: '30px'
        }}>
          {[
            { name: 'Microsoft', domain: 'microsoft.com', logo: 'https://logo.clearbit.com/microsoft.com' },
            { name: 'Apple', domain: 'apple.com', logo: 'https://logo.clearbit.com/apple.com' },
            { name: 'Google', domain: 'google.com', logo: 'https://logo.clearbit.com/google.com' },
            { name: 'Amazon', domain: 'amazon.com', logo: 'https://logo.clearbit.com/amazon.com' },
            { name: 'Facebook', domain: 'facebook.com', logo: 'https://logo.clearbit.com/facebook.com' },
            { name: 'Twitter', domain: 'twitter.com', logo: 'https://logo.clearbit.com/twitter.com' }
          ].map(brand => (
            <div key={brand.domain} style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '16px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
              transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '12px'
              }}>
                <img 
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    marginRight: '12px'
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.backgroundColor = '#f0f0f0';
                    e.target.style.display = 'flex';
                    e.target.style.alignItems = 'center';
                    e.target.style.justifyContent = 'center';
                    e.target.src = `https://ui-avatars.com/api/?name=${brand.name}&background=random&color=fff`;
                  }}
                />
                <div>
                  <h3 style={{
                    margin: '0 0 4px 0',
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#333'
                  }}>{brand.name}</h3>
                  <p style={{
                    margin: 0,
                    fontSize: '14px',
                    color: '#666'
                  }}>{brand.domain}</p>
                </div>
              </div>
              <button style={{
                width: '100%',
                padding: '8px 16px',
                backgroundColor: '#0ea5e9',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onClick={() => alert(`This would show the glassmorphic view for ${brand.name}`)}
              >
                View Details
              </button>
            </div>
          ))}
        </div>
      </main>

      <footer style={{
        marginTop: '40px',
        borderTop: '1px solid #eaeaea',
        paddingTop: '20px',
        textAlign: 'center',
        color: '#666',
        fontSize: '14px'
      }}>
        <p>This is a fully public page with no authentication requirements.</p>
        <Link 
          to="/"
          style={{
            color: '#0ea5e9',
            textDecoration: 'none',
            fontWeight: '500',
            marginTop: '8px',
            display: 'inline-block'
          }}
        >
          Back to Home
        </Link>
      </footer>
    </div>
  );
};

export default CompletelyPublicPage; 